import { CaseStudy, CaseStudyTemplate, Company } from "../CaseStudy";
import technologies from "../technologies";
import GPSTrackThumbnail from "../../../../assets/img/caseStudies/GPSTrack.webp";
import equitrackLogo from "../../../../assets/img/clients/equ-logoAlt.webp";

export default function GPSTrack() {
 const caseStudy = new CaseStudyTemplate(
  "GPS-Track:  Tracking assets with GPS & Sensors",
  (
   <div>
    <p>
     Organisations need reliable, real-time data from assets—whether for fleet tracking, equipment monitoring, or regulatory compliance. The challenge lies in securely capturing this data, integrating it with internal systems, and delivering actionable insights.
    </p>
    <p>
     DEV4 built and continues to evolve Equi-track, a cloud-based platform powered by GPS-Track, our modular, API-first tracking solution. Key features:</p>
    <ul>
     <li>Secure integration with GPS devices and a wide range of sensors.</li>
     <li>Modular architecture, adaptable to any system requiring GPS data collection and analysis.</li>
     <li>Customisable data capture frequency based on asset and client needs.</li>
     <li>Real-time delivery to Equi-track for visualisation and analysis.</li>
    </ul>


    <strong>The Results</strong>
    <ul><li>Asset Visibility: Live tracking of asset location and status.</li>
     <li>Seamless Integration: Easily connects to any business system, supporting diverse operational needs.</li>
     <li>Actionable Insights: Enhanced reporting and analytics empower better asset decisions.</li></ul>
   </div>
  ),
  GPSTrackThumbnail,
  new Company(
   "GPS-track:  Tracking assets with GPS & Sensors",
   equitrackLogo
  ),
  "https://equi-track.co.uk/",
  [
   technologies.PWA,
   technologies.netCore,
   technologies.blazor,
   technologies.sqlServer,
   technologies.azure
  ]
 )

 return (
  <CaseStudy caseStudy={caseStudy} bgColor="rgba(0, 0, 0, 0)" thumbSize="115%"></CaseStudy>
 )
}